import { titleize } from './utils';
import { IrregularMapping } from '@javascript/types/IrregularMapping.js';

const irregularDecode: IrregularMapping = {
  'bmw bikes': 'BMW Bikes',
  'bmw motorrad': 'BMW Motorrad',
  bmw: 'BMW',
  cupra: 'CUPRA',
  gwm: 'GWM',
  'gwm ora': 'GWM ORA',
  jaecoo: 'JAECOO',
  kgm: 'KGM',
  'mercedes-benz': 'Mercedes-Benz',
  mg: 'MG',
  'mg motor uk': 'MG',
  mini: 'MINI',
  omoda: 'OMODA',
};

const irregularDisplay: IrregularMapping = {
  'bmw bikes': 'BMW Bikes',
  byd: 'BYD',
  citroen: 'Citroën',
  ds: 'DS',
  'gwm-ora': 'GWM ORA',
  seat: 'SEAT',
  skoda: 'Škoda',
  smart: 'smart',
  ssangyong: 'SsangYong',
};

const makesEncoding: IrregularMapping = Object.fromEntries(
  [...Object.entries(irregularDisplay), ...Object.entries(irregularDecode)].map(
    ([key, value]) => [value, key]
  )
);

/**
 * Decodes a car make to its proper name.
 * @param make - The car make to decode.
 * @returns The decoded car make or null if input is invalid.
 */
function decodeMake(make: string | null): string | null {
  if (!make) {
    return null;
  }
  const lowerCaseMake = make.toLowerCase();
  return irregularDecode[lowerCaseMake] || titleize(lowerCaseMake);
}

/**
 * Gets the display name for a car make.
 * @param make - The car make to get the display name for.
 * @returns The display name or null if input is invalid.
 */
function displayNameMake(make: string): string {
  const lowerCaseMake = make.toLowerCase();
  return (
    irregularDisplay[lowerCaseMake] ||
    irregularDecode[lowerCaseMake] ||
    titleize(lowerCaseMake)
  );
}

function urlMake(make: string): string {
  return makesEncoding[make] || make.toLowerCase();
}

// Export functions for use in other modules
export { decodeMake, displayNameMake, urlMake };
